import React from 'react';
import { Alert } from '@economic/taco';
import { Trans } from '@lingui/macro';

export function BrowserUpdateAlert() {
    let content: React.ReactNode;

    if (navigator.userAgent.includes('Chrome')) {
        content = (
            <Trans>
                Please note that your current browser version is no longer sufficient; certain functionality may not work
                optimally. Update to the latest version to ensure optimal security and performance. Find a guide on how to update
                your browser{' '}
                <a href="https://support.google.com/chrome/answer/95414?hl=en" target="_blank">
                    here
                </a>
                .
            </Trans>
        );
    } else {
        content = (
            <Trans>
                Please note that your current browser version is no longer sufficient; certain functionality may not work
                optimally. Update to the latest version to ensure optimal security and performance.
            </Trans>
        );
    }

    return (
        <Alert state="error" className="!rounded-none">
            {content}
        </Alert>
    );
}
